<template>
  <div style="background: white">
    <prohead></prohead>
    <div style="width: 100%;margin: auto">
      <div class="banner" style="background: url('../../static/img/c_banner.png');position: relative">

        <div style="position: absolute;left: 43%"> 玩の国 乐の芯</div>
      </div>
      <div style="width: 100%">

        <div class="box5_banner" style="padding-top: 40px;" >

          <div>
            <ul class="tab-title">
              <li v-for="(title,index) in tabTitle" @click="cur=title.cate_name" :class="{active:cur==title.cate_name}">{{title.cate_name}}</li>
            </ul>
          </div>

        </div>





        <div class="chuang" id="ryzz">
          <div style="text-align: center">
            <div class="titlebox" style="padding-top: 65px">创新融合主题式场景体验</div>
            <p class="title_fu">experience</p>
            <img style="margin-top: 10px;" src="../../static/img/biaoti.png" alt="">
          </div>


          <div>
            <p>
              开心玩国，站在更高的视点，更广阔的视角，本着尊重儿童的天性，探索儿童乐园需求的本质，为实现更好的，符合儿童身心愉悦发展规律的，真正受儿童喜爱的场所而设计表达。
              坚守与创新，铸就了开心玩国非凡的内核。坚守为孩子的初心，助力成长成就未来。同时，用创新的理念与工匠的精神，在儿童乐园及其相关产品方面的设计、研发、生产等各个环节与细节成
              就卓越。
              <br>
              一个更具文化内涵、更有故事性、主题更加突出、设计更具特色、玩乐参与性和体验性更强的场景化沉浸式的儿童乐园+应运而生。
              这一强势升级，为开心玩国品牌赋予了更与时俱进的价值观和生命力。
            </p>
          </div>
        </div>
      </div>
      <div style="width: 100%;background: url('../../static/img/bgan111.jpg');text-align: center;position: relative;overflow: hidden;
    text-align: center;
    vertical-align: middle;">
        <div class="box6" id="gsjj" style="width: 1300px;margin:0 auto;">
          <div style="position:absolute;left: 45%">
            <div class="titlebox" style="color: #ffffff; padding-top: 66px">
              主题乐园
            </div>
            <p style="color: #ffffff;">Theme park</p>
            <img style="margin-top: 10px" src="../../static/img/biaoti2.png" alt="">

          </div>
          <div style="margin: 0 auto" class="boxzu">
            <div  v-for="item in datas" :key="item" @click="zhudetails(item.id)"  class="box6_div box11"  style="width: 214px;height: 600px;border-left: 0.5px solid rgb(225,225,225,0.3);border-right: 0.5px solid rgb(225,225,225,0.3);float:left;">
              <div style="margin-top: 400px">
                <p style="font-size: 24px;font-family: PingFang SC;font-weight: bold;color: #FFFFFF;line-height: 45px;">{{item.prd_name}}</p>
                <p style="font-size: 14px;font-family: PingFang SC;font-weight: 400;color: #FFFFFF;line-height: 45px;">{{item.prd_desc}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box5" id="fzlc" style="height: 550px">
        <div class="titlebox" style="padding-top: 65px">十大项目</div>
        <p class="title_fu">project</p>
        <img style="margin-top: 10px;" src="../../static/img/biaoti.png" alt="">

        <div class="box5_banner" style="margin-top: 40px">
          <div class="solution" style="float: left;margin-right: 8px" v-for="items in data" @click="details(items.id)">
            <div class="media-img margin-large-bottom">
              <div style="overflow: hidden; height: 142px;width: 252px;line-height: 185px;text-align: center;margin: auto;border-radius: 10px;">
                <img :src="items.prd_imgurl" alt="" class="img-responsive" style="width: 100%;height: 100%;display: block; border: 0;margin: auto;max-width: 100%;text-align: center;border-radius: 3px;"></div>
              <div class="mask" style="border-radius: 10px;" :style="{background:items.bg_color}">
                <div class="subtitle" style="text-align: center;margin-top: 0px;">
                  <p style="font-size: 20px">{{items.pro_name}}</p>
                  <p style="font-size: 12px;text-align: left;line-height: 20px;margin-top: 1px">{{items.prd_desc}}</p>
                </div>
              </div>
              <div class="linear-link" style="border-radius: 10px;" :style="{background:items.bg_color}">
                <div class="subtitle">
                  <p class="text-white text-middle margin-small-bottom">{{items.prd_name}}</p>
                  <p class="text-white"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Profooter></Profooter>
  </div>

</template>

<script>
import {goAnchor,GetQueryString} from '../../static/js/common';
import Prohead from '../components/Prohead'
import Profooter from "../components/Profooter";
export default {
  name: "index",
  components: {Prohead,Profooter},
  data () {
    return {
      cur: '项目概述',
      tabTitle:[{
        cate_name:'项目概述'
      },{
        cate_name:'品牌简介'
      },{
        cate_name:'品牌文化'
      },{
        cate_name:'荣誉资质'
      }],
      url:'http://child.yohann.cn/',
      activeIndex: '1',
      activeIndex2: '1',
      datas:[],
      data:[],
      navLists:[
        {
          "text":"首页",
          "url":'/'
        },
        {
          "text":"开心玩国",
          "url":'/ProRecommend',
        },
        {
          "text":"创新产品",
          "url":'/ProRecommending',

        },
        {
          "text":"财富世界",
          "url":'/add'
        },
        {
          "text":"加入我们",
          "url":'/Joinus'
        },
        {
          "text":"新闻资讯",
          "url":'/newadd'
        },
        {
          "text":"联系方式",
          "url":'contactus'
        }
      ],
      changeRed:0,
      fullpath:''
    }
  },

  watch: {
    fullpath(a, b) {
      this.$router.go(0);
    }
  },

  created() {
    this.list()
    this.showPhoto()
  },
  mounted() {
    this.$nextTick(() => {
      let maodian=this.GetQueryString('maodian');//进入页面，如果带有锚点参数，则跳转至锚点地方，参数值就是id名
      if(maodian){
        this.goAnchor('#'+maodian);

      }
    });

  },
  methods:{
    zhudetails(id){
      this.$router.push('/zhudetails?id='+id)
    },
    details(id){
      this.$router.push('/prodetails?id='+id)

    },
    list(){
      let formdata = new FormData()
      formdata.append('catename','六大主题')
      formdata.append('page',1)
      formdata.append('limit',6)
      this.$axios.post('/index/Product/ProductList',formdata).then(res => {
        this.datas = res.data.data
        console.log(this.datas)
      });
    },
    showPhoto(){
      let formdata = new FormData()
      formdata.append('catename','十大项目')

      this.$axios.post('/index/Product/ProductList',formdata).then(res => {
        this.data = res.data.data
        console.log(this.data)

      });
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        // 通过 `vm` 访问fetchData，将query参数name，传递过去，进行逻辑处理
        // debugger
        // console.log(to)
        // console.log(from)
        //       console.log(vm.$route); //有值
        //       next()
        if (from.fullPath === "****") {  //关键判断这里区别，自己刷新是 /
          vm.fullpath = from.fullPath;
          this.$router.go(0);
        }

        // vm.fetchData(vm.$route.query.name);
      });
    },
    goAnchor,

    GetQueryString,

  },
}
</script>

<style scoped>
.box11:hover{
  background:rgba(244,205,136,0.6) ;
}
//#ea9475，#e2685e，#4c709c，#35b6c4，#7e66b1

.boxzu>:nth-child(1){
  background-color:yellow;
}
.boxzu :nth-child(1):hover{
  cursor: pointer;
}
.boxzu :nth-child(2):hover{
  cursor: pointer;

}
.boxzu :nth-child(3):hover{
  background:rgba(226,104,94,0.6) ;
  cursor: pointer;

}
.boxzu :nth-child(4):hover{
  background:rgba(76,112,155,0.6) ;
  cursor: pointer;

}
.boxzu :nth-child(5):hover{
  background:rgba(0,196,182,0.6) ;
  cursor: pointer;

}
.boxzu :nth-child(6):hover{
  background:rgba(59,110,102,0.6) ;
  cursor: pointer;

}
.linear-link{
  position: absolute;
  bottom: 0;
  width: 252px;
  font-size: 20px;
  font-family: PingFang;
  font-weight: 500;
  color: #FFFFFF;
  height: 50px;
  background: #D68164;
  opacity: 0.9;
  border-radius: 10px !important;
  line-height: 50px;
}
.solution {
  margin-bottom: 10px;
}
.solution:hover{
  cursor: pointer;
}
.solution .media-img:hover .mask {
  z-index: 5;
  transition: 0.3s;
  opacity: 1;
  transform: scale(1.1);
}
.solution .media-img:hover .mask {
  z-index: 5;
  transition: 0.3s;
  opacity: 1;
  transform: scale(1.1);
}
.solution .media-img .mask {
  opacity: 0;
  z-index: 3;
  background: rgb(40 167 225 / 85%);
  width: 92%;
  height: 92%;
  position: absolute;
  bottom: 0;
  top: -7px;
  left: 1px;
  right: 0;
  transition: 0.3s;
  margin-left: 11px;
  margin-top: 12px;
}
.solution .media-img {
  position: relative;
  width: 252px;
  height: 142px;
}
.solution .media-img .mask .subtitle {
  padding: 17px;
  color: #ffffff;
  text-align: left;
}
.box6{
  height: 600px;
  //background: url("../../static/img/bg3.jpg");

}
.banner_pin div{
  float: left;
}
.box5{
  height:889px;
  text-align: center;
}
.box5_banner{
  width:1300px;
  margin: 0 auto;
}
.box5_bannerimg{
  width: 252px;
  height: 142px;
  float: left;
  margin-right: 8px;
  margin-bottom: 8px;
  position: relative;
}
.box5_bannerimg div{
  width: 100%;
  height: 50px;
  background: #D68164;
  opacity: 0.9;
  border-radius: 10px;
  line-height: 50px;
  font-weight: 500;
  color: #FFFFFF;
  font-size: 20px;
  position: absolute;
  bottom: 0;
}
.box6_div:hover{
  cursor: pointer;
}
.box3{
  margin: 0 auto;
  width: 1920px;
  height: 618px;
  //background: url("../../static/img/bg2.jpg");
}
.box_banner2{
  width: 1300px;
  margin: 0 auto;
  height: 620px;
  text-align: center;
}
.box_imgbanner div{
  float: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 36px;
  text-align: left;
}
.box_imgbanner{
  margin-top: 60px;
}
.banner_pintext{
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.titlebox{
  text-align: center;
  font-size: 40px;
  font-weight: 500;
}
.title_fu{
  font-size: 18px;
  font-weight: 400;
  color: #666666;
  text-align: center;
}
.banner{
  height: 300px;
  font-size: 40px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 300px;
  text-align: center;
}
.banner_kai{
  width: 1300px;
  height: 894px;
  margin: 0 auto;
}
.chuang{
  width: 1300px;
  height: 420px;
  margin: 0 auto;
}
.chuang p{
  margin-top: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/views/ProRecommending.vue